<template>
  <div style="
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    max-width: 240px;
    min-width: 180px;
    overflow: hidden;
    background: #fff;
    border-right: 1px solid #e8ecf1;
  ">
    <div style="flex: 1; overflow-y: auto; padding-top: 8px;">
      <el-menu
        :collapse="$store.state.config.menu.leftCollapse"
        :default-active="activeMenuIndex"
        :key="'menu_' + activeMenuIndex + '_' + currentMenuIndex"
        style="border-right: none; width: 100%;"
        background-color="#fff"
        text-color="#5a6a7a"
        active-text-color="#409eff"
      >
        <FengMenuItem v-for="(item, k) in subMenus" :key="k" :menu="item" :k="k" />
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// ★ 新增：引入菜单项
import FengMenuItem from '../menu/FengMenuItem.vue';
export default {
  name: 'FengMenuLeft',
  // ★ 新增：注册组件
  components: {
	FengMenuItem,
  },
  computed: {
    ...mapState({
      menuConfig: (state) => state.config.menu,
      currentMenuIndex: (state) => state.menu.current,
    }),
    filteredMenus() {
      return this.$store.getters['menu/filteredList'] || [];
    },
    subMenus() {
      const user = this.$store.state.user.user;
      if (!user || !user.role) return [];
      const group = this.filteredMenus[this.currentMenuIndex];
      return (group && group.menus) || [];
    },
    activeMenuIndex() {
      const currentPath = this.$route.path;
      const currentQuery = this.$route.query;
      const menus = this.subMenus;

      const findIndex = (menuList, path, query, prefix = '') => {
        if (!Array.isArray(menuList)) return null;
        for (let i = 0; i < menuList.length; i++) {
          const item = menuList[i];
          const currentIndex = prefix ? `${prefix}_${i}` : String(i);
          let isMatch = false;
          if (item.path) {
            isMatch = path === item.path || path.startsWith(item.path + '/');
            if (isMatch && item.query) {
              const itemQ = item.query || {};
              const targetQ = query || {};
              isMatch = Object.keys(itemQ).every((k) => itemQ[k] == targetQ[k]);
            }
          }
          if (isMatch) return currentIndex;
          if (item.menus && item.menus.length > 0) {
            const found = findIndex(item.menus, path, query, currentIndex);
            if (found) return found;
          }
        }
        return null;
      };

      return findIndex(menus, currentPath, currentQuery) || '0';
    },
  },
};
</script>

<style scoped>
.el-menu-item span,
.el-sub-menu__title span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  display: inline-block;
  vertical-align: middle;
}
.el-menu-item {
  min-width: 0 !important;
}
</style>